import { render, staticRenderFns } from "./born.vue?vue&type=template&id=418cda7c&scoped=true&"
import script from "./born.vue?vue&type=script&lang=ts&"
export * from "./born.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418cda7c",
  null
  
)

export default component.exports